import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ApiPaths } from "../../../api/paths";
import ActiveShieldIcon from "../../../components/icons/ActiveShieldIcon";
import ShieldCard from "../../../components/shield-card/ShieldCard";
import useData from "../../../hooks/use-data";
import { StaffStatisticsType } from "../../../types/staff";
import { toast } from "react-toastify";
import { useAppContext } from "../../../context/app-context";

export default function ManageStaffStats() {
  const { t } = useTranslation(["manageStaff"]);
  const { user } = useAppContext();

  const params = useMemo(
    () => ({
      params: {
        companyName: user?.attributes?.companyName[0],
      },
    }),
    []
  );

  const { data } = useData<StaffStatisticsType>(`${ApiPaths.staffStatistics}`, {
    options: params,
    onError: () => {
      toast(t("error.default", { ns: "common" }), {
        type: "error",
      });
    },
  });
  const mapData = useMemo(
    () => [
      {
        name: t("stats.total", { ns: "manageStaff" }),
        qty: data?.statData?.total,
        color: "bg-purple-light",
        shieldColor: "bg-purple",
        tooltip: t("stats.tooltip.total", { ns: "manageStaff" }),
        icon: <ActiveShieldIcon />,
      },
      {
        name: t("stats.active", { ns: "manageStaff" }),
        qty: data?.statData?.active,
        color: "bg-green-light",
        shieldColor: "bg-green",
        tooltip: t("stats.tooltip.active", { ns: "manageStaff" }),
        icon: <ActiveShieldIcon />,
      },
      {
        name: t("stats.inactive", { ns: "manageStaff" }),
        qty: data?.statData?.inactive,
        color: "bg-orange-light",
        shieldColor: "bg-orange",
        tooltip: t("stats.tooltip.inactive", { ns: "manageStaff" }),
        icon: <ActiveShieldIcon />,
      },
    ],
    [data]
  );
  return (
    <div className="row">
      {mapData.map((stat) => {
        return (
          <div className="col-6 col-md-4 pb-3" key={stat.name}>
            <ShieldCard
              name={stat.name}
              qty={stat.qty}
              color={stat.color}
              shieldColor={stat.shieldColor}
              tooltip={stat.tooltip}
              icon={stat.icon}
            />
          </div>
        );
      })}
    </div>
  );
}
